import React, { useEffect } from "react";
import ZipFinderHome from "../components/zip-finder-home";
import WhatService from '../components/what-service';
import HowToGuidesImage from '../components/how-to-guides-image';
import PopularProjectsNearYou from "../components/popular-projects-near-you";
import ProjectTypesList from "../components/project-types-list";
import DumpsterMadeEasyBbb from "../components/dumpster-made-easy-bbb";
import AreYouAProfessionalDumpster from "../components/are-you-a-professional-dumpster";
import StatesListHome from "../components/state-list-home";
import CitiesListHome from "../components/cities-list-home";
import LayoutHomeDumpster from "../components/layout-home-dumpster";
import ReviewsSection from "../components/reviewsSection";

const DumpsterIndex = ({ pageContext }) => {
    const states = pageContext.states.length > 0 ? pageContext.states : [];
    const codes = pageContext.codes.length > 0 ? pageContext.codes : [];
    const env = pageContext.env;
    const project_types = pageContext.project_types
    const popular_projects = pageContext.popular_projects
    const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const HUB = pageContext.HUB;
    const proReviews = pageContext.reviews || []; 

    if (HUB.length > 0) cities.push(HUB[0])

    const seo_desc = pageContext.seo_desc;
    const seo =
    {
        url: '/',
        env: env,
        code: 'dumpster',
        page: 'home',
        seo_desc: seo_desc,
        schema: pageContext.schemaOrg
    }

    useEffect(() => {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        if(params.about) document.getElementById("state-list-section").scrollIntoView();
    },[])

    return (

        <LayoutHomeDumpster seo={seo} env={env} code='dumpster' hidden={true}>

            <ZipFinderHome
                id='home-zip-code'
                code='dumpster'
                title="Low Prices. Easy Booking."
                text="From trusted local dumpster rental companies"
                button="Find Pros"
                env={env}
                form='book'
            />

            <DumpsterMadeEasyBbb page='home' />

            <ReviewsSection 
                reviews={proReviews}
                title='Millions of Customers Served Since 2008'
                subtitle='Reviews from real customers on 3000+ local dumpster services'
                class='reviews-list-container'
            />

            <WhatService
                env={env}
                class='what-service-bg'
            />

            <PopularProjectsNearYou popular_projects={popular_projects} env={env}/>

            <HowToGuidesImage code="dumpster" class="how-to-guides-bg"/>

            <CitiesListHome
                cities={cities}
                code='dumpster'
                codes={codes}
                env={env}
            />

            <StatesListHome
                states={states}
                code='main'
                title='Find Dumpster Rentals in All 50 States'
                codes={codes}
                env={env}
                class='state-list-bg'
            />

            <ProjectTypesList
                title='Popular Categories'
                project_types={project_types}
                env={env}
                bg="#f7f7f7"
            />

            <AreYouAProfessionalDumpster />

        </LayoutHomeDumpster>
    )
};

export default DumpsterIndex;